import { render, staticRenderFns } from "./expressCampaignEdit.vue?vue&type=template&id=39a37e54&"
import script from "./expressCampaignEdit.vue?vue&type=script&lang=js&"
export * from "./expressCampaignEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports